var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkYoutubeIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "home_web",
    transform: "translate(-1290.000000, -2281.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9-Copy",
    transform: "translate(-2.000000, 2166.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(1262.000000, 115.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(30.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#202020",
    x: 0,
    y: 0,
    width: 22,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "youtube",
    transform: "translate(6.000000, 7.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.75041667,1.10499132 C9.63569444,0.678489591 9.29942708,0.342282982 8.87298611,0.22743924 C8.0939323,0.0142795178 4.97765626,0.0142795178 4.97765626,0.0142795178 C4.97765626,0.0142795178 1.86150174,0.0142795178 1.08244792,0.219357631 C0.664210073,0.334079853 0.319739591,0.678550351 0.205017369,1.10499132 C0,1.88398437 0,3.49951389 0,3.49951389 C0,3.49951389 0,5.12318576 0.205017369,5.89403646 C0.319861111,6.32047743 0.656006944,6.65668404 1.08250868,6.77152778 C1.86970485,6.98474826 4.97777778,6.98474826 4.97777778,6.98474826 C4.97777778,6.98474826 8.0939323,6.98474826 8.87298611,6.77967015 C9.29948785,6.66488715 9.63569444,6.32868056 9.75053819,5.90223959 C9.95553665,5.12318576 9.95553665,3.50771702 9.95553665,3.50771702 C9.95553665,3.50771702 9.96369792,1.88398437 9.75041667,1.10499132 L9.75041667,1.10499132 Z M3.98550348,4.99199652 L3.98550348,2.00703126 L6.57684028,3.49951389 L3.98550348,4.99199652 Z",
    id: "Shape"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkYoutubeIc);
export default __webpack_public_path__ + "static/media/dark_youtube_ic.9fe90c33f79edc3850c319f10d147a40.svg";
export { ForwardRef as ReactComponent };